
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Recommend from './components/Recommend/index.vue'
import Introduce from './components/Introduce/index.vue'
import LearnMap from './components/LearnMap/index.vue'
import ChooseGuide from './components/ChooseGuide/index.vue'
import StudySystem from './components/StudySystem/index.vue'
import More from './components/More/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    Recommend,
    Introduce,
    LearnMap,
    ChooseGuide,
    StudySystem,
    More
  },
  async asyncData(ctx) {
    await ctx.store.$storeActivitys.Calligraphy.loadJson()
  }
})
export default class ActivityCalligraphyPage extends Vue {
  get PageStore() {
    return this.$store.$storeActivitys.Calligraphy
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
